import styled from 'styled-components'
import colors from '../../../configuration/colors'

const RadioLabel = styled.label`
  color: ${colors.victoria}
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  opacity: ${props => props.disabled ? 0.5 : 1};
`

export default RadioLabel



// WEBPACK FOOTER //
// ./src/components/typography/Input/RadioLabel.js